import { Box, Divider, Typography } from '@mui/material';
import { Button, Login, LoginForm } from 'react-admin';
import { Link } from 'react-router-dom';
import GoogleAuthButton from './GoogleAuthButton';

const LoginPage = () => {
  return (
    <Login>
      <LoginForm />
      <Box
        sx={{
          pt: 2,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button component={Link} to="/forgotPassword" variant="text" sx={{ textTransform: 'none' }}>
          <Typography variant="body2">Forgot Password?</Typography>
        </Button>
      </Box>
      <Box sx={{ pt: 2, pb: 2 }}>
        <Divider>
          <Typography variant="body2" color="textSecondary">
            OR
          </Typography>
        </Divider>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          padding: 2,
        }}
      >
        <GoogleAuthButton />
      </Box>
    </Login>
  );
};

export default LoginPage;
